import { PDFRichText } from "../../export-pdf/components/rich-text";
import { PDFTitle } from "../../export-pdf/components/title";

export const PDFObjectives = ({
  title,
  content,
  isContinue,
}: {
  title?: string | null;
  content: string | null;
  isContinue?: boolean;
}) => {
  return (
    <>
      <PDFTitle title={`${title}${isContinue ? " (continued)" : ""}`} />,
      <PDFRichText htmlString={content} fontSize={10} />
    </>
  );
};
